import { areArraysEqual } from "../../../Shared";
export function getAnalyticsOutcomeAddedRemovedResults({ prePack, eventId, modifier, filterName, betslipSelections, }) {
    if (prePack && modifier === "loading") {
        const status = areArraysEqual(prePack.selections.map(x => x.id), betslipSelections.map(x => x.id))
            ? "Added"
            : "Removed";
        return prePack.selections.map(selection => ({
            sportEventId: eventId,
            type: "OutcomeResult",
            metadata: {
                status,
                prePackId: prePack.id,
                filterName,
                selectionId: selection.id,
                fromBetSlip: false,
                isLive: prePack.isLive,
            }
        }));
    }
    else {
        return [];
    }
}
//# sourceMappingURL=getAnalyticsOutcomeAddedRemovedResults.js.map